"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _SearchInput = _interopRequireDefault(require("../../SearchInput"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _styles = require("@mui/styles");
var _react = require("react");
var _constants = require("../constants");
var _Box = _interopRequireDefault(require("../../Box"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var styles = function styles(theme) {
  return {
    notchedOutline: {
      borderColor: theme.palette.primary.main,
      borderWidth: 2
    }
  };
};
var Input = function Input(_ref) {
  var searchExp = _ref.searchExp,
    onSearch = _ref.onSearch,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Search' : _ref$placeholder;
  var ref = (0, _react.useRef)();
  var focusInput = (0, _react.useCallback)(function () {
    if (ref !== null && ref !== void 0 && ref.current) {
      ref.current.focus();
    }
  }, []);
  var handleMouseDown = function handleMouseDown() {
    setTimeout(focusInput, 0);
  };
  var handleInputChange = (0, _react.useCallback)(function (e) {
    var value = e.target.value || '';
    onChange(value);
    onSearch && onSearch(e, value);
  }, [onChange, onSearch]);
  var handleClear = function handleClear() {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box["default"], {
    m: 1,
    onMouseDown: handleMouseDown,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchInput["default"], {
      value: value,
      onChange: handleInputChange,
      debounceTimeout: _constants.SEARCH_INPUT_DEBOUNCE_TIMEOUT,
      autoFocus: true,
      fullWidth: true,
      placeholder: placeholder,
      variant: 'outlined',
      inputRef: ref,
      onClear: handleClear,
      size: 'small',
      inputProps: {
        'data-cy': 'selectSearch',
        'data-cy-role': _constants.dataCyRoleFilterInput
      },
      suffix: searchExp ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment["default"], {
        position: 'end',
        children: "RegEx"
      }) : null
    })
  });
};
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'SelectSearch'
})(Input);